<template>
  <div>
    <section class="top">
      <div class="header">
        <div class="container">
          <div class="columns">
            <div class="column is-6">
              <h1 class="title is-1 has-text-left" data-aos="fade-up">Quizlet niet leuk genoeg?</h1>
              <p class="subtitle is-5 mt-2" data-aos="fade-up">Op zoek naar een alternatief voor Quizlet? Zoek niet verder! Ikleeralles.nl is het leukste overhoorprogramma voor woordjes of begrippen.</p>
              <b-button tag="router-link" to="/aanmelden" type="is-primary" size="is-medium" icon-right="arrow-right">Aan de slag</b-button>
            </div>
            <div class="column is-4 is-offset-2">
              <img class="header-image is-hidden-touch" src="@/assets/undraw/screen.svg" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-white">
      <div class="hero-body mt-5">
        <div class="container">
          <div class="columns">
            <div class="column is-half">
              <img alt="woordjes overhoren" ref="image1" src="@/assets/screenshots/lijstmaken.png" class="pr-5" />
            </div>
            <div class="column is-half">
              <div class="lead" data-aos="fade-left">
                <h1 class="title">
                  Woordjes leren.
                  <span class="anotherhand">Niet meer saai</span>
                </h1>
                <p class="is-size-4">
                  Woordjes leren kost veel tijd en is bijna altijd saai. Het is heel belangrijk op school om een taal te leren. Ook voor andere vakken en een latere opleiding zul je soms begrippen moeten leren.
                  <br /><br />
                  Wij snappen dat je snel je woordjes wil leren. Daarom hebben wij een efficiënte methode ontwikkeld om meteen aan de slag te kunnen. Wij zorgen ervoor dat het stampwerk zo leuk mogelijk is!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <h2 class="title is-2 has-text-centered">Vergelijken</h2>
        <p class="column is-half is-offset-one-quarter has-text-centered is-size-4">Hieronder vergelijken we de aspecten die volgens ons het belangrijkste zijn om leuk en efficiënt woordjes te leren.</p>
        <br />
        <br />
        <table class="table" data-aos="fade-up">
          <thead>
            <tr>
              <th></th>
              <th class="has-text-centered">Ikleeralles.nl</th>
              <th class="has-text-centered grayed-out">Quizlet</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Onbeperkt gratis overhoren</td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
              <td class="has-text-centered">
                <b-icon icon="close" class="grayed-out" />
              </td>
            </tr>
            <tr>
              <td>Medailles verzamelen</td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
              <td class="has-text-centered">
                <b-icon icon="close" class="grayed-out" />
              </td>
            </tr>
            <tr>
              <td>Woordjes kleuren geven</td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
              <td class="has-text-centered">
                <b-icon icon="close" class="grayed-out" />
              </td>
            </tr>
            <tr>
              <td>Lijsten samenvoegen</td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
            </tr>
            <tr>
              <td>Darkmode</td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
              <td class="has-text-centered">
                <b-icon icon="close" class="grayed-out" />
              </td>
            </tr>
            <tr>
              <td>Automatisch woordjes vertalen</td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
              <td class="has-text-centered">
                <b-icon icon="check-bold" class="color-green" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h3 class="title is-2 anotherhand">Klaar om aan de slag te gaan?</h3>
          <b-button tag="router-link" to="/aanmelden" size="is-large" type="is-success" data-aos="fade-up">Registreren</b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
@use "~@/assets/style/landing.scss";
</style>
